import FormattedMessage from 'I18n/components/FormattedMessage';
import useToggle from 'academy-common-lib/hooks/useToggle';
import MobileTopFilterPanel from 'academy-common-lib/features/filters/components/MobileTopFilterPanel';
import { FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
import { usePlaylistItemsSearch } from '../../playlistItems/playlistItemsHooks';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { FilterIcon } from 'foundations-assets/icons/components/FilterIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PlaylistAssignmentsMobileFilter = () => {
  const {
    isShowing,
    show,
    hide
  } = useToggle();
  const {
    totalCount: itemsCount
  } = usePlaylistItemsSearch();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      "data-test-id": "mobile-filter-panel-button",
      onClick: show,
      use: "transparent",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.filters.filtersLink"
        }), /*#__PURE__*/_jsx(FilterIcon, {
          size: "500"
        })]
      })
    }), /*#__PURE__*/_jsx(MobileTopFilterPanel, {
      "data-test-id": "mobile-secondary-filter-panel",
      itemsCount: itemsCount,
      mobileFilterTypes: [FILTER_TYPES.ASSIGNED_BY],
      onCloseClick: hide,
      open: isShowing,
      showSort: false
    })]
  });
};
export default PlaylistAssignmentsMobileFilter;